import { render } from "./BestFit.vue?vue&type=template&id=1c841764&scoped=true&ts=true"
import script from "./BestFit.ts?vue&type=script&lang=ts"
export * from "./BestFit.ts?vue&type=script&lang=ts"

import "./BestFit.scss?vue&type=style&index=0&id=1c841764&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2928705066/src/codestar-connections.eu-west-1.amazonaws.com/git-http/637423592620/eu-west-1/d1c24b47-9e0d-4a51-af9e-d1114251523b/studyportals/WishlistButton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c841764"]])

export default __exports__